import { ReadingLink } from './api';
import { Icon } from './Icon';

/**
 * Further reading beside a rationale.
 *
 * Labelled as reading, never as a source: the questions are original, and
 * calling a page their source would claim a provenance they do not have.
 *
 * Opened in a new tab so the learner does not lose their review, and said so
 * to a screen reader. `no-referrer` because which question someone got wrong
 * is nobody else's business.
 */
export function FurtherReading({ links, id }: { links: ReadingLink[]; id: string }) {
  if (!links.length) return null;
  return (
    <div className="further-reading">
      <h4 id={`reading-${id}`} className="further-reading__heading">Further reading</h4>
      <ul aria-labelledby={`reading-${id}`}>
        {links.map((l) => (
          <li key={l.url}>
            <a href={l.url} target="_blank" rel="noopener noreferrer" referrerPolicy="no-referrer">
              {l.title}
              <Icon name="external-link" />
              <span className="visually-hidden"> (opens in a new tab)</span>
            </a>
            <span className="muted"> — {l.publisher}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
